import { Select, SelectItem } from '@nextui-org/react'
import React from 'react'

const SelectBox = ({radius, label, placement, defaultValue, options, mandatory, register, name, error, selected}) => {

  return (
    <Select
    {...register(name,{onChange: (e) => { selected(e.target.value)}})}
    name={name}
    defaultValue={defaultValue}
    radius={radius}
    label={<div>{label}<span className='text-[red]'>{mandatory && "*"}</span></div>}
    labelPlacement={placement}
    placeholder={label}
    errorMessage={<span className='text-[red]'>{error && error[name] && error[name]?.message}</span>}
    >
    {
    options?.map((item, index)=>(
        <SelectItem key={item?.value} value={item?.value}>{item.name}</SelectItem>
    ))
    }
    </Select>
  )
}

export default SelectBox